import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InformacionComponent } from './informacion/informacion.component';
import { CalendarioComponent } from './calendario/calendario.component';
import { PlantillasComponent } from './plantillas/plantillas.component';
import { DocumentsService } from 'src/app/services/document.service';
import { environment } from 'src/environments/environment';
import { RutinaModel } from 'src/app/models/rutina.model';
import { ActivatedRoute } from '@angular/router';
import { GuiasComponent } from './guias/guias.component';
import {AnalisisAlimentacionComponent} from "./analisis-alimentacion/analisis-alimentacion.component";
import {RegistroEjerciciosComponent} from "./registro-ejercicios/registro-ejercicios.component";
import {ProgresoClienteComponent} from "./progreso-cliente/progreso-cliente.component";
import {ApuntesClienteComponent} from "./apuntes-cliente/apuntes-cliente.component";
import {CuestionarioClienteComponent} from "./cuestionario-cliente/cuestionario-cliente.component";
import { SuplementacionComponent } from './analisis-alimentacion/suplementacion/suplementacion.component';
import Swal from "sweetalert2";
declare var $: any;

@Component({
  selector: 'app-config-avanzada',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CalendarioComponent,
    InformacionComponent,
    PlantillasComponent,
    GuiasComponent,
    AnalisisAlimentacionComponent,
    RegistroEjerciciosComponent,
    ProgresoClienteComponent,
    ApuntesClienteComponent,
    CuestionarioClienteComponent,
    SuplementacionComponent
  ],
  templateUrl: './config-avanzada.component.html',
  styleUrl: './config-avanzada.component.css'
})
export class ConfigAvanzadaComponent {
  inicioPagina = true;
  userInfo: any;
  patternRutinas = 'rutina'
  listaRutinas: any = [];
  patternProgramas = 'programa'
  listaProgramas: any = [];
  listaProgramasFiltrados: any = [];
  detallePrograma: any;
  detalleCliente: any;

  seccionProgramas: boolean = true;
  alimentacionMacros: boolean = true;
  incluyePlanAlimentacion: boolean = false;
  seccionActive: "informacion" | "plantillas" | "guias" | "suplementacion" | "calendario" | "alimentacion" | "ejercicios" | "progreso" | "apuntes" | "cuestionario" = 'informacion';
  seccionActiveId: string; // seccionActive + documentId
  periodoActiveId: number;
  items = Array(3).fill(0);
  documentId: any = null;
  expedienteCliente: any = false;
  clienteDocumentId: string;
  
  // FILTERS
  filtros: any = {
    activo: true
  };

  constructor(
    private documentService: DocumentsService,
    private route: ActivatedRoute,
  ) { }
  ngOnInit(): void {
    this.inicioPagina = true;
    this.userInfo = JSON.parse(localStorage.getItem('userData'));
    console.log(this.userInfo)

    // this.documentId = this.route.snapshot.paramMap.get("id");
    this.route.params.subscribe(params => {
      this.documentId = decodeURIComponent(params['id']);
      console.log('Cliente Document ID:', this.documentId);
      this.validarDocumento(this.documentId);
    });

    this.seccionActiveId = this.seccionActive + this.documentId;
    if(!this.expedienteCliente) {
      // si hay seccion en storage es porque regresó del constructor rutinas|guias
      if(sessionStorage.getItem('seccion')) {
        this.getDetallePrograma(this.documentId, true);
      } else this.getDetallePrograma(this.documentId, false);

      this.getProgramas();
      this.getRutinas();
    } else {
      // si hay seccion en storage es porque regresó del constructor rutinas|guias
      if(sessionStorage.getItem('seccion') && sessionStorage.getItem('seccionProgramaId')) {
        this.documentId = sessionStorage.getItem('seccionProgramaId');
        this.getDetalleCliente(false);
      } else this.getDetalleCliente(true);
    }
  }
  validarDocumento(documentId: string): void {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.expedienteCliente = emailRegex.test(documentId);
    this.clienteDocumentId = documentId;
    console.log('Expediente Cliente:', this.expedienteCliente);
  }

  getDetalleCliente(getProgramaActivo: boolean)
  {
    this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, this.clienteDocumentId).subscribe((res: any) => {
      this.listaProgramasFiltrados = [];
      console.log('detalleCliente', res)
      this.detalleCliente = res;
      let programaActivo = null;
      const hoy = new Date();
      for(let programa of this.detalleCliente.expediente?.programas) {

        const fechaInicio = new Date(programa.periodos[0].fechaInicioDate);
        const fechaFin = new Date(programa.periodos[programa.periodos.length - 1].fechaFinDate);
        if (hoy >= fechaInicio && hoy <= fechaFin) programaActivo = programa;

        let programaInfo = {
          documentId: programa.configuracionPrograma.id,
          nombre: programa.configuracionPrograma.nombre,
          cantPeriodos: programa.configuracionPrograma.cantPeriodos,
          cantSemanas: programa.configuracionPrograma.cantSemanas,
          periodos: programa.periodos
        }
        this.listaProgramasFiltrados.push(programaInfo)
      }
      if(programaActivo != null && getProgramaActivo) { // si el programa está activo lo selecciona
        this.seccionActiveId = this.seccionActive+programaActivo.configuracionPrograma.id;
        this.documentId = programaActivo.configuracionPrograma.id;
        this.alimentacionMacros = programaActivo.configuracionPrograma.alimentacionPorMacros ? programaActivo.configuracionPrograma.alimentacionPorMacros : false;
        this.getDetallePrograma(programaActivo.configuracionPrograma.id, false);
      }
      if(!getProgramaActivo) {
        this.getDetallePrograma(this.documentId, true);
      }
      console.log('listaProgramasFiltrados', this.listaProgramasFiltrados);
    }, err => {
      console.error(err)
    })
  }

  getDetallePrograma(documentId, setSeccionActiva: boolean)
  {
    this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, documentId).subscribe((res: any) => {
      console.log('detallePrograma', res)
      this.detallePrograma = res;
      this.incluyePlanAlimentacion = res.planAlimentacion
      if(setSeccionActiva) {
        this.seccionActive = sessionStorage.getItem('seccion') as "informacion" | "plantillas" | "guias" | "calendario" | "alimentacion" | "ejercicios" | "progreso" | "apuntes" | "cuestionario";
        this.periodoActiveId = sessionStorage.getItem('seccionPeriodoId') ? parseInt(sessionStorage.getItem('seccionPeriodoId'))-1 : null;

        sessionStorage.removeItem('seccion');
        sessionStorage.removeItem('seccionProgramaId');
        sessionStorage.removeItem('seccionPeriodoId');
        this.seccionActiveId = this.seccionActive + this.documentId;
      }
    }, err => {
      console.error(err)
    })
  }
  getProgramas() {
    console.log("getProgramas()")
    this.documentService.getDocumentsByType(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.patternProgramas
    ).subscribe({
      next: (data: any) => {
        console.log(data)
        this.listaProgramas = [...data.content];
        // this.listaProgramasFiltrados = [...data.content];
        this.filtrarProgramas();

        const index = this.listaProgramas.findIndex((item) => item.documentId === this.detallePrograma?.documentId);
        if (index !== -1) this.detallePrograma = {...this.listaProgramas[index]};
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
      }
    })
  }
  getRutinas(){
    const filters: any = {
      "documentContainerId": this.userInfo.documentContainerId,
      "empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(environment.businessId, this.patternRutinas, query).subscribe({
        next: (data: any) => {
          console.log(data)
          // if(this.dataTableRutinas) {
          //   this.dataTableRutinas.destroy();
          //   this.dataTableRutinas = null; // Eliminar la referencia
          // }
          this.listaRutinas = [];
          this.listaRutinas = data;
          // this.inicializarDataTableRutinas();
        },
          error: (error: any) => {
          console.error(error);
          this.listaRutinas = [];
          // this.inicializarDataTableRutinas();
        }
      });
    }, 1500);
  }
  filtrarProgramas() {
    this.listaProgramasFiltrados = this.listaProgramas.filter((programa) => {
        return programa.activo === this.filtros.activo && programa.tipo == '2';
    });
    console.log(this.listaProgramas)
  }

  selectPrograma(programa) {
    this.inicioPagina = false;
    this.documentId = programa.documentId
    this.detallePrograma = programa;
  }
  changeSeccionActive(value: 'informacion' | 'plantillas' | 'guias' | 'suplementacion' | 'calendario' | 'alimentacion' | 'ejercicios'| 'progreso' | 'apuntes' | 'cuestionario', programa: any, indexPeriodo: number | null) {
    this.inicioPagina = false;
    this.seccionActive = value;
    this.seccionActiveId = value+programa.documentId;
    if(value == 'calendario') { 
      this.periodoActiveId = indexPeriodo;
    } else this.periodoActiveId = null;
    this.documentId = programa.documentId
    if(!this.expedienteCliente) {
      this.detallePrograma = programa;
    } else {
      this.getDetallePrograma(programa.documentId, false);
    }
  }
  changePeriodoActive() {

  }

  arrRutinasEnPeriodo: any = [];
  modalRutinasEnPeriodo()
  {
    this.arrRutinasEnPeriodo = []
    console.log("modalRutinasEnPeriodo")
    this.inicializarDataTableRutinasModal();
    this.inicializarDataTableRutinasEnPeriodoModal();
    $('#modal-rutinasEnPeriodo').modal({backdrop: 'static', keyboard: false})
    $("#modal-rutinasEnPeriodo").modal('show');
  }
  agregarRutinaAPeriodo(rutina: RutinaModel)
  {
    this.arrRutinasEnPeriodo.push(rutina)

    // Remover el platillo de listaPlatillos
    const index = this.listaRutinas.indexOf(rutina);
    if (index !== -1) {
      this.listaRutinas.splice(index, 1);
    }
    this.inicializarDataTableRutinasModal();
    this.inicializarDataTableRutinasEnPeriodoModal();
  }
  eliminarRutinaDePeriodo(rutina: RutinaModel) {
    console.log(`Eliminando platillo:`, rutina);
  
    // Remover el platillo de constructorGuiaModal.platillos
    const index = this.arrRutinasEnPeriodo.indexOf(rutina);
    if (index !== -1) {
      this.arrRutinasEnPeriodo.splice(index, 1);
    }
  
    // Agregar el platillo de vuelta a listaRutinas si no está ya en la lista
    const existeEnLista = this.listaRutinas.some(p => p.nombre === rutina.nombre);
    if (!existeEnLista) {
      this.listaRutinas.push(rutina);
    }
    this.inicializarDataTableRutinasModal();
    this.inicializarDataTableRutinasEnPeriodoModal(); // Actualiza la tabla si es necesario
  }
  inicializarRutinasEnPeriodoModal()
  {
    this.getRutinas();
    this.arrRutinasEnPeriodo = []; 
    this.inicializarDataTableRutinasModal();
    this.inicializarDataTableRutinasEnPeriodoModal();
  }

  dataTableRutinasModal: any;
  inicializarDataTableRutinasModal()
  {
    if (this.dataTableRutinasModal) {
      this.dataTableRutinasModal.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableRutinasModal = $('#dataTable-listaRutinas-modal').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  dataTableRutinasEnPeriodoModal: any;
  inicializarDataTableRutinasEnPeriodoModal()
  {
    if (this.dataTableRutinasEnPeriodoModal) {
      this.dataTableRutinasEnPeriodoModal.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableRutinasEnPeriodoModal = $('#dataTable-listaRutinasEnPeriodo-modal').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }

  cambiaTipoAlimentacion(tipo){
    let etiqueta: string
    etiqueta = 'Conteo de Macros'
    if(!tipo){
      etiqueta = 'Dieta'
    }
    Swal.fire({
      title: 'Cambiar Tipo de Alimentación',
      html: '¿Seguro que desea cambiar el tipo de alimentación a ' + etiqueta + ' para este programa?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.alimentacionMacros = tipo
        const index = this.detalleCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.detallePrograma?.documentId);
        let programas = [...this.detalleCliente.expediente.programas];
        programas[index].configuracionPrograma.alimentacionPorMacros = tipo;
        let expedienteClienteDocument: any = {
          expediente: {
            programas: programas
          }
        }
        console.log('expendiente actualizado')
        this.documentService.updateDocumentInContainer(
            environment.businessId,
            this.userInfo.documentContainerId,
            this.detalleCliente.documentId,
            "cliente",
            null,
            expedienteClienteDocument
        ).subscribe({
          next: (data: any) => {
            console.log(data);
          },
          error: (error) => {
            console.log(error);
          },
          complete: () => {
          }
        })
      }
    })

  }
}
